
'use client'
import React from 'react'
import Link from 'next/link';
import Image from 'next/image';


const Hero = ({ onDownload, onApply }) => {

  return (
    <section className="relative overflow-hidden bg-[#081E2D]">
      <div className="absolute inset-0">
        <img
          src="https://cdn.msu.edu.in/msu-reavamp/phd/bg-img.webp"
          alt="University"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-linear-to-br from-[#081E2D] via-[#081E2D]/90 to-[#0475B3]/40" />
        <div className="absolute top-20 right-1/3 w-64 h-64 rounded-full bg-[#0475B3]/10 blur-3xl" />
        <div className="absolute bottom-10 left-20 w-48 h-48 rounded-full bg-[#FFA201]/10 blur-3xl" />
      </div>

      <div className="relative max-w-(--max-page-width) px-(--container-padding) mx-auto py-16 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#FFA201]/15 border border-[#FFA201]/30 rounded-full px-4 py-1.5 mb-6"
              style={{ animation: "fadeInDown 0.6s ease" }}>
              <span className="w-2 h-2 rounded-full bg-[#FFA201] animate-pulse" />
              <span className="text-[#FFA201] text-xs font-black tracking-widest">Ph.D. Admission 2026</span>
            </div>

            <h1 className="text-white font-black leading-[1.05] mb-5"
              style={{ fontSize: "clamp(2.5rem, 6vw, 4rem)", animation: "fadeInUp 0.7s ease 0.1s both" }}>
              Doctor of{" "}
              <span className="text-[#FFA201]">Philosophy</span> <br />
              Programme (Ph.D.)
            </h1>

            <p className="text-blue-200 text-xl font-bold mb-2"
              style={{ animation: "fadeInUp 0.7s ease 0.2s both" }}>
              The Future of Research is Skill-Led
            </p>
            <p className="text-blue-300/80 text-md max-w-lg mb-8 leading-relaxed"
              style={{ animation: "fadeInUp 0.7s ease 0.3s both" }}>
              Industry-aligned, application-driven doctoral education. Move beyond theory — create solutions that reshape industry, governance and society.
            </p>

            <div className="flex flex-wrap gap-3 mb-10"
              style={{ animation: "fadeInUp 0.7s ease 0.4s both" }}>
              {/* <a href="https://msu-website-all-objects.s3.ap-south-1.amazonaws.com/pdf/PhD_Brochure.pdf"
                target="_blank"
                className="bg-[#FFA201] text-[#081E2D] font-bold px-8 py-3.5 rounded-full text-sm hover:scale-105 hover:shadow-xl hover:shadow-amber-400/30 transition-all duration-200">
                Download Brochure →
              </a> */}
              {/* <DownloadButton text={hero.buttons.download} onClick={onDownload} /> */}
              <button onClick={onDownload}
                className="bg-[#FFA201] text-[#081E2D] font-bold px-8 py-3.5 rounded-full text-sm hover:scale-105 hover:shadow-xl hover:shadow-amber-400/30 transition-all duration-200">
                Download Brochure →
              </button>

              <Link
                target="_blank"
                rel="noopener noreferrer"
                href="https://application.msu.edu.in/msu-ph-d-application-form"
                className="border border-white/25 text-white font-semibold px-7 py-3.5 rounded-full text-sm hover:bg-white/10 transition-all duration-200 backdrop-blur-sm">
                Apply Now
              </Link>
            </div>
          </div>


          <div className="lg:sticky lg:top-20 hidden md:hidden lg:block">
            <Image
              src="https://cdn.msu.edu.in/msu-reavamp/phd/Ph_D_banner.webp"
              alt="Ph.D. Programme"
              width={399}
              height={400}
              priority
              className="h-auto w-full"
            />

          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero